<template>
  <b-offcanvas
    id="theme-settings-offcanvas"
    v-model="useLayout.isRightSidebarOpen"
    title="Theme Settings"
    body-class="overflow-y-hidden p-0"
    header-class="align-items-center bg-primary  text-white"
    placement="end"
  >
    <template #default>
      <div class="p-0" data-simplebar style="height: 100vh">
        <div>
          <div class="card mb-0 p-3">
            <h5 class="mt-0 font-16 fw-bold mb-3">Choose Layout</h5>
            <div class="row">
              <div class="col-4">
                <div class="form-check card-radio">
                  <input
                    id="customizer-layout01"
                    name="data-layout"
                    type="radio"
                    value="vertical"
                    class="form-check-input"
                  />
                  <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout01">
                    <span class="d-flex h-100">
                      <span class="flex-shrink-0">
                        <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                          <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                          ></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                          ></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                          ></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                          ></span>
                        </span>
                      </span>
                      <span class="flex-grow-1">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-block p-1"></span>
                        </span>
                      </span>
                    </span>
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Vertical</h5>
              </div>
              <div class="col-4">
                <div class="form-check card-radio">
                  <input
                    id="customizer-layout02"
                    name="data-layout"
                    type="radio"
                    value="horizontal"
                    class="form-check-input"
                  />
                  <label class="form-check-label p-0 avatar-md w-100" for="customizer-layout02">
                    <span class="d-flex h-100 flex-column">
                      <span
                        class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                      >
                        <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                        <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"></span>
                        <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                        <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                        <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                      </span>
                      <span class="bg-light d-block p-1"></span>
                    </span>
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Horizontal</h5>
              </div>
            </div>

            <h5 class="my-3 font-16 fw-bold">Color Scheme</h5>

            <div class="colorscheme-cardradio">
              <div class="row">
                <div class="col-4">
                  <div class="form-check card-radio">
                    <input
                      id="layout-color-light"
                      class="form-check-input"
                      type="radio"
                      name="data-bs-theme"
                      value="light"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="layout-color-light">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column bg-white rounded-2">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color" class="bg-white rounded-2 h-100">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                          </span>
                          <span class="d-flex h-100 flex-column bg-white rounded-2">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Light</h5>
                </div>

                <div class="col-4">
                  <div class="form-check card-radio">
                    <input
                      id="layout-color-dark"
                      class="form-check-input"
                      type="radio"
                      name="data-bs-theme"
                      value="dark"
                    />
                    <label class="form-check-label p-0 avatar-md w-100 bg-black" for="layout-color-dark">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-secondary border-opacity-25 border-3 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary border-opacity-25 border-3 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary border-opacity-25 border-3 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary border-opacity-25 border-3 rounded w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light-lighten d-flex p-1 align-items-center border-bottom border-opacity-25 border-primary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-primary border-opacity-25 border-3 rounded ms-auto"
                            ></span>
                            <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                            <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                            <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                          </span>
                          <span class="bg-light-lighten d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
                </div>
              </div>
            </div>

            <div id="layout-width">
              <h5 class="my-3 font-16 fw-bold">Layout Mode</h5>

              <div class="row">
                <div class="col-4">
                  <div class="form-check card-radio">
                    <input
                      id="layout-mode-fluid"
                      class="form-check-input"
                      type="radio"
                      name="data-layout-mode"
                      value="fluid"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="layout-mode-fluid">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column rounded-2">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                          </span>
                          <span class="bg-light d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Fluid</h5>
                </div>
                <div id="layout-boxed" class="col-4">
                  <div class="form-check card-radio">
                    <input
                      id="layout-mode-boxed"
                      class="form-check-input"
                      type="radio"
                      name="data-layout-mode"
                      value="boxed"
                    />
                    <label class="form-check-label p-0 avatar-md w-100 px-2" for="layout-mode-boxed">
                      <div id="sidebar-size" class="border-start border-end">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column rounded-2">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color" class="border-start border-end h-100">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                          </span>
                          <span class="bg-light d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Boxed</h5>
                </div>

                <div id="layout-detached" class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="data-layout-detached"
                      class="form-check-input"
                      type="radio"
                      name="data-layout-mode"
                      value="detached"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="data-layout-detached">
                      <span class="d-flex h-100 flex-column">
                        <span class="bg-light d-flex p-1 align-items-center border-bottom">
                          <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                          ></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                        </span>
                        <span class="d-flex h-100 p-1 px-2">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 flex-column p-1 px-2">
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100"
                              ></span>
                            </span>
                          </span>
                        </span>
                        <span class="bg-light d-block p-1 mt-auto px-2"></span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Detached</h5>
                </div>
              </div>
            </div>

            <h5 class="my-3 font-16 fw-bold">Topbar Color</h5>

            <div class="row">
              <div class="col-4">
                <div class="form-check card-radio">
                  <input
                    id="topbar-color-light"
                    class="form-check-input"
                    type="radio"
                    name="data-topbar-color"
                    value="light"
                  />
                  <label class="form-check-label p-0 avatar-md w-100" for="topbar-color-light">
                    <div id="sidebar-size">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </div>

                    <div id="topnav-color">
                      <span class="d-flex h-100 flex-column">
                        <span
                          class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                        >
                          <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                          <span
                            class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                          ></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"></span>
                        </span>
                        <span class="bg-light d-block p-1"></span>
                      </span>
                    </div>
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Light</h5>
              </div>

              <div class="col-4" style="--ct-dark-rgb: 64, 73, 84">
                <div class="form-check card-radio">
                  <input
                    id="topbar-color-dark"
                    class="form-check-input"
                    type="radio"
                    name="data-topbar-color"
                    value="dark"
                  />
                  <label class="form-check-label p-0 avatar-md w-100" for="topbar-color-dark">
                    <div id="sidebar-size">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                            <span class="d-block p-1 bg-primary-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-dark d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </div>

                    <div id="topnav-color">
                      <span class="d-flex h-100 flex-column">
                        <span
                          class="bg-dark d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                        >
                          <span class="d-block p-1 bg-primary-lighten rounded me-1"></span>
                          <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-auto"></span>
                          <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                          <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                          <span class="d-block border border-primary border-opacity-25 border-3 rounded ms-1"></span>
                        </span>
                        <span class="bg-light d-block p-1"></span>
                      </span>
                    </div>
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
              </div>

              <div class="col-4">
                <div class="form-check card-radio">
                  <input
                    id="topbar-color-brand"
                    class="form-check-input"
                    type="radio"
                    name="data-topbar-color"
                    value="brand"
                  />
                  <label class="form-check-label p-0 avatar-md w-100" for="topbar-color-brand">
                    <div id="sidebar-size">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-primary bg-gradient d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </div>

                    <div id="topnav-color">
                      <span class="d-flex h-100 flex-column">
                        <span
                          class="bg-primary bg-gradient d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                        >
                          <span class="d-block p-1 bg-light opacity-25 rounded me-1"></span>
                          <span class="d-block border border-3 border opacity-25 rounded ms-auto"></span>
                          <span class="d-block border border-3 border opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border opacity-25 rounded ms-1"></span>
                          <span class="d-block border border-3 border opacity-25 rounded ms-1"></span>
                        </span>
                        <span class="bg-light d-block p-1"></span>
                      </span>
                    </div>
                  </label>
                </div>
                <h5 class="font-14 text-center text-muted mt-2">Brand</h5>
              </div>
            </div>

            <div>
              <h5 class="my-3 font-16 fw-bold">Menu Color</h5>

              <div class="row">
                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-color-light"
                      class="form-check-input"
                      type="radio"
                      name="data-menu-color"
                      value="light"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-color-light">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                          </span>
                          <span class="bg-light d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Light</h5>
                </div>

                <div class="col-4" style="--ct-dark-rgb: 64, 73, 84">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-color-dark"
                      class="form-check-input"
                      type="radio"
                      name="data-menu-color"
                      value="dark"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-color-dark">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-dark d-flex h-100 flex-column p-1 px-2">
                              <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                              <span
                                class="d-block border border-secondary rounded border-opacity-25 border-3 w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary rounded border-opacity-25 border-3 w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary rounded border-opacity-25 border-3 w-100 mb-1"
                              ></span>
                              <span
                                class="d-block border border-secondary rounded border-opacity-25 border-3 w-100 mb-1"
                              ></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color">
                        <span class="d-flex h-100 flex-column">
                          <span
                            class="bg-light d-flex p-1 align-items-center border-bottom border-secondary border-primary border-opacity-25"
                          >
                            <span class="d-block p-1 bg-primary-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-secondary rounded border-opacity-25 border-3 ms-auto"
                            ></span>
                            <span
                              class="d-block border border-secondary rounded border-opacity-25 border-3 ms-1"
                            ></span>
                            <span
                              class="d-block border border-secondary rounded border-opacity-25 border-3 ms-1"
                            ></span>
                            <span
                              class="d-block border border-secondary rounded border-opacity-25 border-3 ms-1"
                            ></span>
                          </span>
                          <span class="bg-dark d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Dark</h5>
                </div>
                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-color-brand"
                      class="form-check-input"
                      type="radio"
                      name="data-menu-color"
                      value="brand"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-color-brand">
                      <div id="sidebar-size">
                        <span class="d-flex h-100">
                          <span class="flex-shrink-0">
                            <span class="bg-primary bg-gradient d-flex h-100 flex-column p-1 px-2">
                              <span class="d-block p-1 bg-light-lighten rounded mb-1"></span>
                              <span class="d-block border opacity-25 rounded border-3 w-100 mb-1"></span>
                              <span class="d-block border opacity-25 rounded border-3 w-100 mb-1"></span>
                              <span class="d-block border opacity-25 rounded border-3 w-100 mb-1"></span>
                              <span class="d-block border opacity-25 rounded border-3 w-100 mb-1"></span>
                            </span>
                          </span>
                          <span class="flex-grow-1">
                            <span class="d-flex h-100 flex-column">
                              <span class="bg-light d-block p-1"></span>
                            </span>
                          </span>
                        </span>
                      </div>

                      <div id="topnav-color">
                        <span class="d-flex h-100 flex-column">
                          <span class="bg-light d-flex p-1 align-items-center border-bottom border-secondary">
                            <span class="d-block p-1 bg-dark-lighten rounded me-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-auto"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded ms-1"
                            ></span>
                          </span>
                          <span class="bg-primary bg-gradient d-block p-1"></span>
                        </span>
                      </div>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Brand</h5>
                </div>
              </div>
            </div>

            <div id="sidebar-size">
              <h5 class="my-3 font-16 fw-bold">Sidebar Size</h5>

              <div class="row">
                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-default"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="default"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-default">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column p-1 px-2">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Default</h5>
                </div>

                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-compact"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="compact"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-compact">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column p-1">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Compact</h5>
                </div>

                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-small"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="condensed"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-small">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column" style="padding: 2px">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Condensed</h5>
                </div>

                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-small-hover"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="sm-hover"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-small-hover">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="bg-light d-flex h-100 border-end flex-column" style="padding: 2px">
                            <span class="d-block p-1 bg-dark-lighten rounded mb-1"></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                            <span
                              class="d-block border border-3 border-secondary border-opacity-25 rounded w-100 mb-1"
                            ></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Hover View</h5>
                </div>

                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-full"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="full"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-full">
                      <span class="d-flex h-100">
                        <span class="flex-shrink-0">
                          <span class="d-flex h-100 flex-column">
                            <span class="d-block p-1 bg-dark-lighten mb-1"></span>
                          </span>
                        </span>
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Full Layout</h5>
                </div>

                <div class="col-4">
                  <div class="form-check sidebar-setting card-radio">
                    <input
                      id="leftbar-size-fullscreen"
                      class="form-check-input"
                      type="radio"
                      name="data-sidenav-size"
                      value="fullscreen"
                    />
                    <label class="form-check-label p-0 avatar-md w-100" for="leftbar-size-fullscreen">
                      <span class="d-flex h-100">
                        <span class="flex-grow-1">
                          <span class="d-flex h-100 flex-column">
                            <span class="bg-light d-block p-1"></span>
                          </span>
                        </span>
                      </span>
                    </label>
                  </div>
                  <h5 class="font-14 text-center text-muted mt-2">Fullscreen Layout</h5>
                </div>
              </div>
            </div>

            <div id="layout-position">
              <h5 class="my-3 font-16 fw-bold">Layout Position</h5>

              <div class="btn-group radio" role="group">
                <input
                  id="layout-position-fixed"
                  type="radio"
                  class="btn-check"
                  name="data-layout-position"
                  value="fixed"
                />
                <label class="btn btn-soft-primary w-sm" for="layout-position-fixed">Fixed</label>

                <input
                  id="layout-position-scrollable"
                  type="radio"
                  class="btn-check"
                  name="data-layout-position"
                  value="scrollable"
                />
                <label class="btn btn-soft-primary w-sm ms-0" for="layout-position-scrollable">Scrollable</label>
              </div>
            </div>

            <div id="sidebar-user">
              <div class="d-flex justify-content-between align-items-center mt-3">
                <label class="font-16 fw-bold m-0" for="sidebaruser-check">Sidebar User Info</label>
                <div class="form-check form-switch">
                  <input id="sidebaruser-check" type="checkbox" class="form-check-input" name="sidebar-user" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="border-top p-3 text-center">
        <div class="row">
          <div class="col-6">
            <button id="reset-layout" type="button" class="btn btn-light w-100">Reset</button>
          </div>
        </div>
      </div>
    </template>
  </b-offcanvas>
</template>

<script lang="ts">
import { useLayoutStore } from '@/stores/layout'
import { onMounted, defineComponent } from 'vue'

export default defineComponent({
  setup() {
    const useLayout = useLayoutStore()

    onMounted(() => {
      useLayout.initConfig()
    })

    return {
      useLayout,
    }
  },
})
</script>
